export enum UserTypes {
  STUDENT = '1',
  COLLEGE_STUDENT = '2',
  EDUCATIONAL_PROFESSIONAL = '3',
  PARENT_OR_ADULT = '4',
  CHILD = '5',
}

export enum CreatedByTypes {
  SELF = 'self',
  EDUCATOR = 'educator',
  ADULT = 'adult',
}
